import React from "react";

const CustomTitleAndSubTitle = ({ title, subTitle, currency }) => {
  return (
    <div>
      <h3 className="text-sm text-gray-700 lg:text-lg">{title}</h3>
      <h3 className="text-sm text-black lg:text-xl">
        {subTitle}{" "}
        <span className="text-[9px] lg:text-sm text-black"> {currency}</span>
      </h3>
    </div>
  );
};

export default CustomTitleAndSubTitle;
